import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import React, { PureComponent } from "react"; //Limitless imports

import { withLogging } from "./Logging";
import { TranslationContext } from "../../../common/hooks/translation/TranslationContext";
/**
 * The Internationalisation HOC, uses the resourceBundle in the context to find a translated value
 *
 * @param {React.Component} WrappedComponent
 * @param {string} className
 */

export var withi18n = function withi18n(WrappedComponent, className) {
  var TranslatedComponent = /*#__PURE__*/function (_PureComponent) {
    _inherits(TranslatedComponent, _PureComponent);

    var _super = _createSuper(TranslatedComponent);

    function TranslatedComponent() {
      _classCallCheck(this, TranslatedComponent);

      return _super.apply(this, arguments);
    }

    _createClass(TranslatedComponent, [{
      key: "render",
      value: function render() {
        var _this = this;

        return /*#__PURE__*/React.createElement(TranslationContext.Consumer, null, function (context) {
          return /*#__PURE__*/React.createElement(WrappedComponent, Object.assign({
            t: context.t
          }, _this.props));
        });
      }
    }]);

    return TranslatedComponent;
  }(PureComponent);

  if (className) {
    return withLogging(TranslatedComponent, className);
  } else {
    return TranslatedComponent;
  }
};